<template>
  <div>
    <div
      v-for="(item, index) in nav"
      :key="item.index"
      @contextmenu.prevent="handleContextMenu($event, item)"
    >
      <avue-draggable
        v-if="!item.children"
        v-canvas-bounds="{ canvas: contain.config, enabled: container.isEditing, beginMove: beginSelectionMove }"
        v-bind="item"
        class="screen-component-layer"
        :style="{ '--screen-selection-width': container.stepScale + 'px' }"
        :z-index="nav.length - 1 - index"
        :scale="container.stepScale"
        :disabled="!contain.menuFlag || isLocked(item)"
        :data-node-id="item.index"
        :step="container.stepScale"
        :width="item.component.width"
        :height="item.component.height"
        :ref="common.DEAFNAME + item.index"
        :id="common.DEAFNAME + item.index"
        v-show="!isHidden(item)"
        @over="handleOver"
        @focus="handleFocus"
        @blur="handleBlur"
      >
        <div v-if="templatePlaceholder(item)" class="screen-template-placeholder">{{ templatePlaceholder(item) }}</div>
        <component
          v-else-if="!contain.isComponentTemplateEditing || supportsStyleTemplate(item)"
          :ref="common.NAME + item.index"
          :id="common.NAME + item.index"
          :is="common.COMPNAME + item.component.name"
          v-bind="renderNode(item)"
          :data-script="Number(item.dataType) === 6 ? undefined : getFunction(item.dataScript)"
          :preview-mode="contain.isPreview || contain.isComponentTemplateEditing"
          :data-formatter="Number(item.dataType) === 6 ? undefined : getFunction(item.dataFormatter)"
          :click-formatter="Number(item.dataType) === 6 ? undefined : getFunction(item.clickFormatter)"
          :echart-formatter="Number(item.dataType) === 6 ? undefined : getFunction(item.echartFormatter)"
          :label-formatter="Number(item.dataType) === 6 ? undefined : getFunction(item.labelFormatter)"
          :formatter="Number(item.dataType) === 6 ? undefined : getFunction(item.formatter)"
          :width="item.component.width"
          :data-query="contain.isComponentTemplateEditing || Number(item.dataType) === 6 ? {} : getJson(item.dataQuery)"
          :height="item.component.height"
          :animation="!contain.menuFlag"
          :theme="(item.option || {}).theme"
          :disabled="!contain.menuFlag"
          :scale="container.stepScale"
          :option="renderNode(item).option"
          :home-url="contain.isComponentTemplateEditing ? '' : contain.config.url"
          title=""
          :click="handleClick"
        />
        <p v-else role="alert">此组件暂不支持配置样式模板，请移除后保存。</p>
        <button v-if="!container.isEditing && item.component.prop !== 'navigation' && !['productList', 'deviceList'].includes(item.component.prop) && item.navigation && item.navigation.type !== 'none'"
                type="button" class="screen-page-action" :data-page-action="item.index"
                :aria-label="item.name || item.title || '页面导航'"
                :disabled="item.navigation.type === 'back' && !contain.canNavigateBack"
                :title="item.navigation.type === 'back' && !contain.canNavigateBack ? '当前是访问入口，没有上级页面' : (item.name || item.title)"></button>
      </avue-draggable>
      <subgroup v-if="item.children" ref="groups" :nav="item.children"></subgroup>
    </div>
  </div>
</template>

<script>
import common from "@/config";
import { locateNode, canEditNode } from '@/editor/core/node-operations';
import { selectionContains, selectionMovePlan, selectionMoveDelta } from '@/editor/core/selection-drag';
import { componentRect } from '@/editor/core/component-size';
import canvasBounds from '@/editor/directives/canvas-bounds';
import { TEMPLATE_RENDERERS } from '@/editor/core/component-template';
import { templatePreviewNodes, templatePreviewPlaceholder } from '@/runtime/template-preview';
import DeviceMap from '@/components/DeviceMap/index.vue';
export default {
  name: "subgroup",
  directives: { canvasBounds },
  // 局部绑定优先于旧Avue后装的同名全局组件，画布、预览和分享统一使用新地图。
  components: { 'avue-echart-map': DeviceMap },
  inject: ["contain", "container"],
  provide() {
    return {
      contain: this.contain,
      container: this.container,
    };
  },
  props: {
    nav: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      common: common,
      token: localStorage.getItem("x-access-token"),
    };
  },
  computed: {
    renderNodes () { return this.contain.isComponentTemplateEditing ? templatePreviewNodes(this.nav, { runtimeSource: true }) : this.nav; }
  },
  methods: {
    templatePlaceholder (item) { return (this.contain.isTemplateEditing || this.contain.isTemplatePreview || (this.contain.obj && this.contain.obj.templatePreview)) ? templatePreviewPlaceholder(item) : ''; },
    renderNode (item) { return this.contain.isComponentTemplateEditing ? this.renderNodes.find(node => node.index === item.index) || item : item; },
    supportsStyleTemplate (item) { return TEMPLATE_RENDERERS.includes(item.component.name) && item.component.name === item.component.prop; },
    isLocked(item) {
      const found = locateNode(this.contain.nav, item.index);
      return !!item.locked || !!(found && found.ancestors.some(node => node.locked));
    },
    isHidden(item) {
      const found = locateNode(this.contain.nav, item.index);
      return !!item.display || !!(found && found.ancestors.some(node => node.display));
    },
    getFunction(fun) {
      if (this.contain.isPreview || this.contain.isComponentTemplateEditing) return undefined;
      if (!this.validatenull(fun)) {
        try {
          return eval(fun);
        } catch (e) {
          console.warn(e);
          return function () {};
        }
      }
    },
    getFunctionExec(funStr) {
      if (this.contain.isPreview || this.contain.isComponentTemplateEditing) return null;
      if (!this.validatenull(funStr)) {
        try {
          // 把字符串变成一个函数并返回执行结果
          const fn = new Function(`return (${funStr})`)(); // 注意加括号！
          if (typeof fn === "function") {
            return fn(); // 执行函数并返回结果
          }
        } catch (e) {
          console.warn("getFunction 执行失败:", e);
        }
      }
      return null;
    },
    getJson(str) {
      if (this.validatenull(str)) return {};
      if (typeof str == "string") {
        try {
          return JSON.parse(str);
        } catch {
          // this.$message.error('接口参数格式错误，请输入json的数据')
          return this.getFunctionExec(str);
        }
      }
      return str;
    },
    //点击事件交互//
    handleClick({ type, child, value }) {
      if (this.contain.isPreview || this.contain.isComponentTemplateEditing) return;
      // 防止重复触发
      if (this._clickLock) return;
      this._clickLock = true;

      setTimeout(() => {
        this._clickLock = false;
      }, 0); // 一个事件循环就够了
      if (type === "tabs") {
        const indexList = child.index;
        indexList.forEach((index) => {
          const paramName = child.paramName;
          const item = this.contain.findlist(index);
          if (item.name.indexOf("地图") != -1) {
            this.$refs[this.common.NAME + index][0].changeProduct(value);
          } else {
            if (item.dataType == 1) {
              //动态数据
              if (!item.url) return;
              let params = {};
              if (item.dataQuery) {
                params = this.getJson(item.dataQuery);
              } else {
                params = {};
              }
              if (value != "all") {
                params[paramName] = "productId = " + value;
              }else
                params[paramName] = "";
              item.dataQuery = JSON.stringify(params);
            } else if (item.dataType == 2) {
              if (item.parameter[paramName] != undefined) {
                item.parameter[paramName] = value;
              }
            }
            this.$refs[this.common.NAME + index][0].updateData();
          }
        });
      }
    },
    //刷新数据
    handleRefresh(tip = true) {
      this.$refs[
        this.common.NAME + this.contain.activeObj.index
      ][0].updateData(Number(this.contain.activeObj.dataType) === 6 ? { refreshCharging: true } : undefined);
      if (tip) {
        this.$message.success("刷新成功");
      }
    },
    //获取对象
    handleGetObj(val) {
      const local = this.$refs[`${this.common.DEAFNAME}${val}`];
      if (local) return local;
      for (const group of (this.$refs.groups || [])) {
        const found = group.handleGetObj(val);
        if (found) return found;
      }
    },
    handleOver({ index }) {
      if (!this.container.isEditing) return;
      this.contain.overactive = index;
    },
    handleFocus({ index }) {
      if (!this.container.isEditing) return;
      this._componentDrag = { index };
      this.index = index;
      this.container.gradeFlag = true;
      const refs = this.handleGetObj ? this.handleGetObj(index) : null
      const frame = Array.isArray(refs) ? refs[0] : refs
      const covered = frame && frame.rangeActive ? this.contain.active.includes(index) : selectionContains(this.contain.nav, this.contain.active, index)
      if (this.contain.keys.ctrl) {
        if (!Array.isArray(this.contain.active)) {
          this.contain.handleInitActive();
        }
        if (!covered) this.contain.active.push(index);
      } else if (!covered) {
        this.contain.active = [index];
      }
    },
    beginSelectionMove (anchorFrame, event) {
      const nodes = this.contain.nav, plan = selectionMovePlan(nodes, this.contain.active, anchorFrame.index)
      if (!plan) return null
      const start = this._componentDrag, pageId = this.contain.activePageId
      const projectId = this.contain.projectRecord && this.contain.projectRecord.id
      const selected = JSON.stringify(this.contain.active), step = this.container.stepScale
      const canvas = { width: this.contain.config.width, height: this.contain.config.height }
      const pointer = { x: event.clientX, y: event.clientY }
      let delta = { x: 0, y: 0 }, moved = false
      const valid = () => !this._isDestroyed && this.container.isEditing && !this.container.panning && this.contain.nav === nodes &&
        this.contain.activePageId === pageId && (this.contain.projectRecord && this.contain.projectRecord.id) === projectId &&
        JSON.stringify(this.contain.active) === selected && this.container.stepScale === step &&
        this.contain.config.width === canvas.width && this.contain.config.height === canvas.height
      plan.entries.forEach(entry => {
        const refs = entry.node.index === anchorFrame.index ? anchorFrame : this.handleGetObj(entry.node.index)
        entry.frame = Array.isArray(refs) ? refs[0] : refs
      })
      const render = value => plan.entries.forEach(entry => {
        if (entry.frame && !entry.frame._isDestroyed) { entry.frame.setLeft(entry.left + value.x); entry.frame.setTop(entry.top + value.y) }
      })
      const restore = () => plan.entries.forEach(entry => {
        const current = locateNode(this.contain.nav, entry.node.index)
        const position = current ? current.node : entry
        if (entry.frame && !entry.frame._isDestroyed) { entry.frame.setLeft(Number(position.left) || 0); entry.frame.setTop(Number(position.top) || 0) }
      })
      const cancel = () => {
        restore()
        if (this._componentDrag === start) { this._componentDrag = null; this.container.gradeFlag = false }
      }
      return {
        move: event => {
          if (!valid()) { restore(); return }
          delta = selectionMoveDelta(plan, { x: Math.round((event.clientX - pointer.x) * step * 100) / 100,
            y: Math.round((event.clientY - pointer.y) * step * 100) / 100 }, canvas)
          moved = true
          render(delta)
        },
        finish: () => {
          if (start) start.selectionHandled = true
          if (this._componentDrag === start) this.container.gradeFlag = false
          const current = plan.roots.map(entry => locateNode(nodes, entry.node.index))
          if (!valid() || current.some((entry, index) => !entry || entry.node !== plan.roots[index].node || !canEditNode(entry)) ||
              plan.entries.some(entry => !locateNode(nodes, entry.node.index) || locateNode(nodes, entry.node.index).node !== entry.node ||
                Number(entry.node.component.width) !== entry.width || Number(entry.node.component.height) !== entry.height)) {
            restore(); return
          }
          if (!moved || (!delta.x && !delta.y)) return
          this.contain.rememberStructure()
          plan.entries.forEach(entry => { this.$set(entry.node, 'left', entry.left + delta.x); this.$set(entry.node, 'top', entry.top + delta.y) })
          this.contain.rememberStructure()
        },
        cancel
      }
    },
    handleBlur({ index, left, top, width, height }) {
      const start = this._componentDrag;
      this._componentDrag = null;
      if (!this.container.isEditing || this.container.panning) return;
      this.container.gradeFlag = false;
      if (start && start.selectionHandled) return;
      const target = this.contain.findlist(index || this.index);
      if (!target.component || this.isLocked(target)) return;
      if (Array.isArray(this.contain.activeObj)) return;
      const refs = this.$refs[this.common.DEAFNAME + (index || this.index)];
      const frame = Array.isArray(refs) ? refs[0] : refs;
      const bounded = componentRect({ left, top, width, height }, this.contain.config);
      ({ left, top, width, height } = bounded);
      // 边界限制后父属性可能不变，仍须同步拖拽库内部状态。
      if (frame) {
        frame.setLeft(left); frame.setTop(top);
        frame.baseWidth = width; frame.baseHeight = height;
      }
      this.$set(target.component, "width", width);
      this.$set(target.component, "height", height);
      this.$set(target, "left", left);
      this.$set(target, "top", top);
    },
    handleContextMenu(event, item) {
      if (this.container.isEditing) {
        // 子组件的右键不能继续冒泡选中外层分组。
        event.stopPropagation();
        this.contain.handleContextMenu(event, item);
      }
    },
  },
};
</script>

<style>
.screen-template-placeholder { display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; color: #91b6cf; background: #102c40; font-size: 20px; }
.screen-component-layer.avue-draggable {
  /* 旧库自带10px padding；画布X/Y和宽高应直接对应内容，不留额外壳层。 */
  box-sizing: border-box;
  padding: 0;
  border: 0;
}
</style>
